/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Grid from '@material-ui/core/Grid';

//----------------------------------------------------------------------//
// CSS.                                                                 //
//----------------------------------------------------------------------//

import styles from './FuturePanel.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

type TypeProps = {|
  children?: React.Node,
|};

function FuturePanel(props: TypeProps): React.StatelessFunctionalComponent<*> {
  const { children, t }: TypeProps = props;

  return (
    <Grid className={styles['future-panel']} item={true} xs={6}>
      <h2>{t('general:future')}</h2>
      {children}
    </Grid>
  );
}

export default translate()(observer(FuturePanel));
